import type { Middleware } from "@reduxjs/toolkit";

import { isAction } from "@reduxjs/toolkit";
import { isDebugMode } from "@v2/hooks/useIsDebugMode";
import { getMostRecentViewingUser } from "@v2/trpc/routes/user";
import { canUseDOM } from "replo-utils/dom/misc";

// Copied from https://github.com/jarretmoses/react-native-redux-example/blob/aa20bcbe54b5e15cf1c817a394df6fbacd87a63c/app/store/middleware/logging.js
const loggingMiddleware: Middleware = (store) => (next) => (action) => {
  const user = getMostRecentViewingUser();
  const params = canUseDOM ? new URLSearchParams(window.location.search) : null;
  const isSuperuser = user?.isSuperuser ?? false;
  if (!isDebugMode(isSuperuser, params)) {
    return next(action);
  }

  const reduxLoggingToConsole = JSON.parse(
    localStorage.getItem("replo.debug.reduxLoggingToConsole") ?? "false",
  );

  if (reduxLoggingToConsole && isAction(action)) {
    console.debug(
      "%cINFO:",
      "color: yellow",
      `Dispatching a ${action.type} action with payload:`,
      (action as { payload?: unknown }).payload,
      "and params",
      (action as { params?: unknown }).params,
    );
  }
  const result = next(action);
  if (reduxLoggingToConsole) {
    console.debug("%cNext State:", "color: cyan", store.getState());
  }
  return result;
};

export default loggingMiddleware;
